import './KodanshaWheel.scss';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { DiscoverItem } from '../../Models/DiscoverItem';
import KodanshaWheelItem from './KodanshaWheelItem';
import { useAtom, useAtomValue } from 'jotai';
import { Link } from '../../Devon/Components/InkyLink';
import { FetchWheelAtom } from '../../store/DiscoverStore';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/virtual';
// import 'swiper/css/pagination';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper';
import SliderArrow from '../Assets/icons/SliderArrow';
import { Swiper as T } from 'swiper/types';
import { useWindowSize } from '../Hooks/useWindowSize';
import WheelBullets from './WheelBullets';
import { FreeModeOptions } from 'swiper/types/modules/free-mode';
import { clearBrowseData } from '../../utils/utils';
import Log from '../Services/Logger';
import { LoginOverlayVisible } from '../../store/OverlayStore';
import { uuid } from '@tinymce/tinymce-react/lib/es2015/main/ts/Utils';

const copyArray = (arr, times) => {
    if (times <= 0) {
        return [];
    }
    return arr.concat(copyArray(arr, times - 1));
};


const HardCoded: DiscoverItem[] = [
    {
        'type': 'product',
        'displayType': 'Series',
        'content': {
            'id': 23,
            'ageRating': 'none',
            'title': 'Air Gear',
            'description': 'Ikki Minami is a junior high school student with a dream&mdash;to become the best Air Trek rider in town. It won&apos;t be easy, as he faces a lot of competition from boys and girls alike. What is Air Trek? Just the latest craze that involves taking a two-wheel inline skate and adding a motor, suspension, and a shock absorber to enable the wearer to execute the wildest, wackiest, most aggressive moves you can imagine. Ikki has a lot to learn as he fights his way to the top in this wild, sexy manga from the creator of Tenjho Tenge!',
            'thumbnails': [
                {
                    'width': 1200,
                    'height': 960,
                    'url': 'https://d3nqfnht5m17hp.cloudfront.net/statics/Publications/31625/Pages/page-0001.jpg',
                    'color': 'blue',
                },
            ],
            saleStatus: '',
            'tags': [],
            'readableUrl': 'air-gear',
            'author': 'none',
            'price': 0,
        },
    },
];

interface KodanshaWheelProps {
    discoverId: number;
    title: string;
    secondTitle?: string;
    buttonUrl?: string;
    useCTA?: boolean;
    ctaText?: string;
    preFetchedItems?: DiscoverItem[];
}

export function KodanshaWheel(props: KodanshaWheelProps): JSX.Element {
    const { width } = useWindowSize();

    const [shadowSize, setShadowSize] = useState<{ width: number; height: number; top: number }>({
        width: 0,
        height: 0,
        top: 0,
    });

    const [wheelContainerSize, setWheelContainerSize] = useState<number>(0);

    const [hover, setHover] = useState(false);
    // const [test, setTest] = useState(false);

    const [discoverArray, fetchDiscover] = useAtom(FetchWheelAtom);
    const [isLoaded, setIsLoaded] = useState(false);
    const loginOverlayVisible = useAtomValue(LoginOverlayVisible);
    const [discoverItems, setDiscoverItems] = useState<DiscoverItem[]>([]);
    const [mainTitle, setMainTitle] = useState('');
    const [secondTitle, setSecondTitle] = useState('');
    const [page, setPage] = useState(0);
    const ref = useRef<any>();
    const SwiperRef = useRef<T>();

    let buttonUrl = '/discover/' + props.discoverId;
    if (props.buttonUrl) buttonUrl = props.buttonUrl;

    const calculateWheelItemSize = (): { width: number; height: number; top: number } => {
        // If we don't have any items in the wheel, we don't need to run this function
        if (discoverItems.length === 0) {
            return;
        }

        // To make a copy of series height from the shadow for the shadow
        const children = ref.current?.children;
        try {
            if (children && children.length > 0 && children[0].children[0]) {

                const exactChild = children[0].children[0].children[0].children[0].children[0];

                setShadowSize({
                    width: exactChild.getBoundingClientRect().width,
                    height: exactChild.getBoundingClientRect().height,
                    top: exactChild.getBoundingClientRect().top,
                });
                return {
                    width: exactChild.getBoundingClientRect().width,
                    height: exactChild.getBoundingClientRect().height,
                    top: exactChild.getBoundingClientRect().top,
                };
            }
        } catch (error) {
            console.log('error', error);
        }


        return { width: 0, height: 0, top: 0 };
    };

    const onNextClicked = () => {
        SwiperRef.current.slideNext();
    };

    const onPrevClicked = () => {
        SwiperRef.current.slidePrev();
    };


    useEffect(() => {
        Log.debug('props.discoverId', props.discoverId);
    }, []);

    useEffect(() => {
        if (props.discoverId === null && !props.preFetchedItems) {
            setDiscoverItems(copyArray(HardCoded, 10) as DiscoverItem[]);
        } else if (props.discoverId === null && props.preFetchedItems) {
            setDiscoverItems(props.preFetchedItems);
        } else {
            fetchDiscover(props.discoverId).then(() => {
                setIsLoaded(true);
                setDiscoverItems(discoverArray[props.discoverId].items as DiscoverItem[]);
            }).then(() => {
                setWheelContainerSize(ref.current.getBoundingClientRect().height);
                // setTest(true);
            });
        }

        //This is temp until we add this to the endpoint.
        setMainTitle(props.title);
        const splitTitle = props.title?.split('#');
        if (splitTitle?.length > 1) {
            setSecondTitle(splitTitle[0].toString().toUpperCase());
            setMainTitle(splitTitle[1].toString());
        }
        //End Temp
    }, []);

    useEffect(() => {
        const onArrow = (event) => {
            if (event.code === 'ArrowRight' && !loginOverlayVisible) {
                onNextClicked();
            }

            if (event.code === 'ArrowLeft' && !loginOverlayVisible) {
                onPrevClicked();
            }
        };

        document.addEventListener('keydown', onArrow);

        return () => {
            document.removeEventListener('keydown', onArrow);
        };
    }, [loginOverlayVisible]);


    const calculateSlidesPerViewBasedOnWidth = useCallback((width: number) => {
        return width < 768 ? 2 : 4;
    }, []);


    const onBulletClicked = (index: number): void => {
        SwiperRef.current.slideTo(index * 4);
    };

    //console.log('discoverItems', discoverItems);
    
    if(discoverItems?.length <1) {
        Log.info('KodanshaWheel: discoverItems is empty, hiding wheel');
        return (<></>)
    }

    return (
        <section onMouseOver={(): void => {
            wheelContainerSize !== 0 && calculateWheelItemSize() && setHover(true);
        }} onMouseLeave={(): void => setHover(false)} className='kodansha-wheel-container'>

            <div className='max-kodansha-wheel-container'>

                <div className={'KodanshaWheel'}>

                    <div className='wheel-header'>
                        <div className='wheels-titles-wrapper'>
                            <h3 aria-label={'second title for wheels' + props.secondTitle}
                                className={'wheel-second-title'}>{props.secondTitle ?? secondTitle}</h3>
                            <h2 aria-label={'main title for wheels' + mainTitle}
                                className={'wheel-title'}>{mainTitle}</h2>
                        </div>
                        {width > 768 && <div className='bullets-wrapper'>
                            <WheelBullets
                                onBulletClicked={onBulletClicked}
                                numberOfBullets={SwiperRef.current ? Math.ceil(SwiperRef.current.slides.length / calculateSlidesPerViewBasedOnWidth(width)) : 0}
                                active={SwiperRef.current ? Math.ceil(SwiperRef.current.realIndex / calculateSlidesPerViewBasedOnWidth(width)) : 0} />
                        </div>}
                    </div>

                    <div className='swiper-and-shadow-wrapper'>
                        {width > 768 && hover && wheelContainerSize !== 0 &&
                            // {test &&
                            <>

                                <div onClick={onPrevClicked} className='wheel-shadow-container'
                                     aria-label={'go to previous slide'}
                                     style={{
                                         width: shadowSize.width * 4,
                                         height: shadowSize.height,
                                         left: -4 * shadowSize.width,
                                     }}>


                                    {page !== 0 &&
                                        <div className='prev navigation-icons'
                                             onClick={(e) => {
                                                 e.stopPropagation();
                                                 onPrevClicked();
                                             }}
                                             style={{
                                                 right: 15,
                                                 top: shadowSize.height / 2 - 17.5, // 17.5 half of the arrow size
                                             }}>
                                            <SliderArrow />
                                        </div>}

                                    <div className='wheel-shadow-inner-wrapper'>
                                        <div className='inner-relative wheel-shadow-container-left'>
                                            {Array.from(Array(Math.min(SwiperRef.current.realIndex,
                                                4)).keys()).map((data => {
                                                return <div style={{ minWidth: shadowSize.width }} key={data}
                                                            className='shadow-item' />;
                                            }))}
                                        </div>
                                    </div>
                                </div>


                                <div onClick={onNextClicked}
                                     aria-label={'go to next slide'}
                                     className='wheel-shadow-container'
                                     style={{
                                         width: shadowSize.width * 4,
                                         height: shadowSize.height,
                                         right: -4 * shadowSize.width,
                                     }}>

                                    {SwiperRef.current.slides.length - SwiperRef.current.realIndex > 4 &&
                                        <div className='next navigation-icons'
                                             onClick={(e) => {
                                                 e.stopPropagation();
                                                 onNextClicked();
                                             }}
                                             style={{
                                                 left: 15,
                                                 top: shadowSize.height / 2 - 17.5, // 17.5 half of the arrow size
                                             }}>
                                            <SliderArrow />

                                        </div>}

                                    <div className='wheel-shadow-inner-wrapper'>
                                        <div className='inner-relative wheel-shadow-container-right'>
                                            {SwiperRef.current.slides.length - SwiperRef.current.realIndex > 4 && Array.from(Array(Math.min(SwiperRef.current.slides.length - SwiperRef.current.realIndex - 4,
                                                4)).keys()).map((data => {
                                                return <div style={{ minWidth: shadowSize.width }} key={data}
                                                            className='shadow-item' />;
                                            }))}
                                        </div>
                                    </div>
                                </div>

                            </>}


                        {discoverItems !== null && <Swiper
                            ref={ref}
                            spaceBetween={15}
                            slidesPerView={2}
                            slidesPerGroup={2}
                            touchEventsTarget={'container'}
                            freeMode={width < 768}
                            modules={[FreeMode]}
                            onSwiper={(swiper) => {
                                SwiperRef.current = swiper;
                            }}
                            navigation={{
                                prevEl: '.prev',
                                nextEl: '.next',
                            }}
                            onResize={(swiper) => {
                                swiper.params.freeMode = {
                                    ...swiper.params.freeMode as FreeModeOptions,
                                    enabled: width < 768,
                                };
                                // (swiper.params.freeMode as FreeModeOptions).enabled = width < 768;
                                ref.current && setWheelContainerSize(ref.current.getBoundingClientRect().height);
                                calculateWheelItemSize();
                                swiper.update();
                            }}
                            onEnded={() => {
                                setPage(999);
                            }}
                            onSlideChange={() => {
                                setPage(SwiperRef.current.realIndex);
                            }}
                            breakpoints={{
                                320: {
                                    slidesPerView: 2.2,
                                    slidesPerGroup: 2,
                                },
                                576: {
                                    slidesPerView: 2.2,
                                    slidesPerGroup: 2,
                                },
                                768: {
                                    slidesPerView: 4,
                                    slidesPerGroup: 4,
                                },
                            }}
                        >
                            {discoverItems.map((product, index) => {
                                if (index >= 16 && !props.preFetchedItems) {
                                    return;
                                } else if (index >= 20 && props.preFetchedItems)
                                    return;

                                return <SwiperSlide key={`${product.content.id}-${index}`}>
                                    <div key={product.content.id} aria-label={'main wheel'} className='ItemContainer'>
                                        <KodanshaWheelItem product={product} key={product.content.id}
                                                           cta={product.cta}
                                                           title={product.content.title} />
                                    </div>

                                </SwiperSlide>;
                            })}
                        </Swiper>}

                    </div>

                </div>


                {(discoverItems?.length > 15 || props.useCTA === true) &&
                    <div className={'cta'}>
                        {buttonUrl.startsWith("/")&&( //Assume internal link
                            <Link to={buttonUrl} onClick={clearBrowseData}>
                                <KodanshaArrow text={props?.ctaText ? props.ctaText : 'view more'} withArrow={true} />
                            </Link>
                        )}

                        {!buttonUrl.startsWith("/")&&( // external link
                            <a href={buttonUrl} >
                                <KodanshaArrow text={props?.ctaText ? props.ctaText : 'view more'} withArrow={true} />
                            </a>
                        )}
                    </div>
                }

            </div>

        </section>
    );
}